// extracted by mini-css-extract-plugin
module.exports = {"gridSection":"books-page_gridSection__xG6pR","emptyState":"books-page_emptyState__gMOMc"};